import type { NumberFormat } from './types';

const FORMATS_SUPPORTED_CURRENCY_OVERRIDES = new Set<NumberFormat>([
    'currency',
    'currencyInt',
]);

const FORMATS_SUPPORTED_FRACTION_OVERRIDES = new Set<NumberFormat>([
    'number',
    'currency',
    'currencyInt',
    'percent',
]);

export {
    FORMATS_SUPPORTED_CURRENCY_OVERRIDES,
    FORMATS_SUPPORTED_FRACTION_OVERRIDES,
}
